module.exports = __webpack_public_path__ + "assets/img/extractionTarot_Tit.24b029e5.png";